import { BASE_COMMENT_FRAGMENT } from '../fragments/baseComment';

export const COMMENTS_QUERY = `
  query CommentsQuery(
    $offerId: ID!
    $size: Int
    $page: Int
    $anchorCommentId: ID
  ) {
    public {
      commentsAndReplies(
        offerId: $offerId
        size: $size
        page: $page
        anchorCommentId: $anchorCommentId
      ) {
        edges {
          ...BaseCommentFragment
          replyTo {
            ...BaseCommentFragment
          }
        }
        pageInfo {
          total
          totalPages
          page
        }
      }
    }
  }

  ${BASE_COMMENT_FRAGMENT}
`;

export const COMMENTS_QUERY_V2 = `
  query CommentsQuery(
    $offerId: ID!
    $limit: Int
    $after: String
    $sortBy: CommentSortOptionsV2
    $ignoreComments: [ID!]
  ) {
    public {
      commentsAndRepliesV2(
        offerId: $offerId
        limit: $limit
        after: $after
        sortBy: $sortBy
        ignoreComments: $ignoreComments
      ) {
        edges {
          ...BaseCommentFragment
          replyTo {
            ...BaseCommentFragment
          }
        }
        pageInfo {
          hasNextPage
          hasPreviousPage
          pageSize
          endCursor
          startCursor
        }
      }
    }
  }

  ${BASE_COMMENT_FRAGMENT}
`;
